import React from "react";
import member from "../../assets/images/dao/memebr.png";
import { AiOutlineTwitter } from "react-icons/ai";
import { FaTelegramPlane } from "react-icons/fa";
import Paginationn from "../pagination/paginationn";

import "./daoMembers.css";

export default function DaoMembers() {
  const data: any = [
    {
      title: "title",
      subTitle: "Lorem Ipsum is simply",
      para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    },
    {
      title: "title",
      subTitle: "Lorem Ipsum is simply",
      para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    },
    {
      title: "title",
      subTitle: "Lorem Ipsum is simply",
      para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    },
    {
      title: "title",
      subTitle: "Lorem Ipsum is simply",
      para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    },
    {
      title: "title",
      subTitle: "Lorem Ipsum is simply",
      para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    },
    {
      title: "title",
      subTitle: "Lorem Ipsum is simply",
      para: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    },
  ];
  return (
    <div className="members-container container-fluid p-md-5 p-sm-1">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-12">
            <h1 className="memebrs-title">
              our <span>DAO</span> Members
            </h1>
          </div>
          <div className="col-md-6 col-12 ">
            <div className="row g-0">
              <div className="col-4">
                <button className="btn-all">All</button>
              </div>
              <div className="col-8">
                <div className="search">
                  <i className="fa fa-search"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search DAO members"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          {data.map((item: any, index: any) => {
            return (
              <div className="col-md-4 col-12 mt-5">
                <div className="member-card p-2">
                  <div className="row m-2">
                    <div className="col-4 d-flex justify-content-center align-items-center">
                      <img src={member} alt="card-image" className="card-img" />
                    </div>
                    <div className="col-8 p-2 d-flex flex-column align-items-start justify-content-center">
                      <h1 className="memebr-card-title">{item.title}</h1>
                      <p>{item.subTitle}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 text-start m-2">
                      <p className="">{item.para}</p>
                    </div>
                  </div>
                  <div className="circle-social-icons1">
                    <FaTelegramPlane className="social-icons" />
                  </div>
                  <div className="circle-social-icons2">
                    <AiOutlineTwitter className="social-icons" />
                  </div>
                </div>
              </div>
            );
          })}
          <div className="mt-5">
            <Paginationn />
           </div>
        </div>
      </div>
    </div>
  );
}
